import React, { useState, useEffect } from 'react';
import CertificateFlagEn from '../../assets/images/ceritifcate.png';
import { Button } from '@mui/material';

function Certificate({ username, handleCloseCertificateModal }) {
  const [imageUri, setUri] = useState(null);

  useEffect(() => {
    // Setup the Canvas
    const canvas = document.getElementById('canvas');
    const ctx = canvas.getContext('2d');

    const img = new Image();
    img.src = CertificateFlagEn;
    // console.log("username", username);
    if (username?.length != 0) {
      img.onload = function () {
        // Set Canvas resolution as per image
        canvas.width = img.width;
        canvas.height = img.height;
        canvas.crossOrigin = 'Anonymous';

        // Draw Image & Add Name
        ctx.font = 'bold 100pt Arial, cursive';
        const userName = username;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        ctx.fillStyle = '#bd8e33';
        ctx.textAlign = 'center';
        ctx.fillText(userName, canvas.width / 2, canvas.height / 1.9);

        // Show the Image in the UI
        img.uri = canvas.toDataURL('image/jpg');
        setUri(img.uri);
      };
    }
  }, [username]);

  return (
    <>
      <div className="modalBackground-certificate">
        <div className="modal-container-certificate">
          <div className="popup-header-certificate">
            <canvas id="canvas" className="certificate-canvas"></canvas>
          </div>
          <div>
            <div className="row" style={{ marginLeft: '40%', marginBottom: "20px" }}>
              <Button
                sx={{ width: '20%' }}
                variant="contained"
                onClick={() => {
                  const link = document.createElement('a');
                  link.download = `${username}.jpg`;
                  link.href = imageUri;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
              >
                Download
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Certificate;
